import * as React from 'react';
import { Box, Chip, IconButton, Paper, Stack, Typography } from '@mui/material';
import { MoreVert } from '@mui/icons-material';
import dayjs from 'dayjs';

import { EZoneStatus } from 'enums';
import { IZoneWithActions } from 'models';
import { getZoneTableRowOptions } from 'utils';
import { useAppSelector } from 'store/store.hook';
import { selectCurrentUserInfo } from 'store/slices/auth.slice';

import { Popup } from './popup';
import { ReactComponent as ZoneIconCode } from '../assets/images/zone_icon_code.svg';

interface ZoneCardProps {
  zone?: IZoneWithActions;
  maxWidth?: number | string;
}

export const ZoneCard: React.FC<ZoneCardProps> = (props) => {
  const { zone = null, maxWidth = '100%' } = props;
  const { isAdmin } = useAppSelector(selectCurrentUserInfo);

  if (!zone) {
    return (
      <Paper
        sx={{
          width: '100%',
          maxWidth,
        }}
      >
        <Box
          sx={{
            paddingX: 2,
            paddingY: 1,
          }}
        >
          No zone data
        </Box>
      </Paper>
    );
  }

  const items = getZoneTableRowOptions(zone, isAdmin);

  return (
    <Paper sx={{ width: '100%', maxWidth }}>
      <Box sx={{ paddingX: 2, paddingY: 1 }}>
        <Box sx={{ display: 'flex', alignItems: 'center' }}>
          <ZoneIconCode />
          <Typography color="primary" variant="caption" sx={{ fontWeight: 600 }}>
            ZONE #{zone.code}
          </Typography>

          <Box sx={{ marginLeft: 'auto' }}>
            <Popup items={items} width={zone.status === EZoneStatus.ACTIVE ? 200 : 140}>
              <IconButton color="primary" size="small" onClick={() => {}}>
                <MoreVert fontSize="inherit" />
              </IconButton>
            </Popup>
          </Box>
        </Box>

        <Box sx={{ display: 'flex', alignItems: 'flex-start', paddingTop: 3, paddingBottom: 2 }}>
          <Box sx={{ lineHeight: 1 }}>
            <Typography variant="subtitle2" sx={{ lineHeight: 1 }}>
              {zone.name}
            </Typography>
            <Typography variant="caption" color="textSecondary" sx={{ lineHeight: 1, fontSize: 9 }}>
              Date Created {dayjs(zone.created_at).format('MM/DD/YYYY')}
            </Typography>
          </Box>
        </Box>

        <Box sx={{ maxWidth: 140 }}>
          <Typography sx={{ fontSize: 10 }}>{zone.address}</Typography>
        </Box>

        {zone.service_items.length > 0 && (
          <Stack direction="row" spacing={0.5} sx={{ width: '100%', overflow: 'hidden' }}>
            {zone.service_items.map((serviceItem) => (
              <Chip
                key={`service-item-${serviceItem.id}`}
                label={serviceItem.name}
                size="small"
                sx={{ borderRadius: 1, backgroundColor: '#FFA922', fontSize: 10 }}
              />
            ))}
          </Stack>
        )}
      </Box>
    </Paper>
  );
};
